export const SUBSCRIPTION_ACTION_TYPES = Object.freeze({
  SET_LOADING: 'subscription/SET_LOADING',
  SET_ERROR: 'subscription/SET_ERROR',
  CLEAR: 'subscription/CLEAR',
  SET_STATE: 'subscription/SET_STATE',
});

export const initialSubscriptionState = Object.freeze({
  subscription: { status: 'NONE', trialUsed: false },
  access: null,
  trialDays: 21,
  plans: [
    { id: 'plan-3', name: '3 Month', amountInr: 0, durationMonths: 3 },
    { id: 'plan-12', name: '12 Month', amountInr: 0, durationMonths: 12 },
  ],
  loading: false,
  error: null,
  synced: false,
});

export default function subscriptionReducer(state = initialSubscriptionState, action) {
  if (!action || typeof action !== 'object') return state;
  switch (action.type) {
    case SUBSCRIPTION_ACTION_TYPES.SET_LOADING:
      return { ...state, loading: Boolean(action.payload) };
    case SUBSCRIPTION_ACTION_TYPES.SET_ERROR:
      return { ...state, loading: false, error: action.payload ? String(action.payload) : null };
    case SUBSCRIPTION_ACTION_TYPES.CLEAR:
      return { ...initialSubscriptionState };
    case SUBSCRIPTION_ACTION_TYPES.SET_STATE:
      return {
        ...state,
        ...action.payload,
        loading: false,
        error: null,
        synced: true,
      };
    default:
      return state;
  }
}
